export default "__VITE_ASSET__sFhAiTBW__"